import { createSelector } from '@ngrx/store'
import { AppState } from '../../../../store'

import * as fromTeam from '../reducers/team.reducer'

export const getTeamState = createSelector(
  (state: AppState) => state.team,
  _ => _
)

export const {
  selectIds: getTeamIds,
  selectEntities: getTeamEntities,
  selectAll: getTeamsSelector,
  selectTotal: getTotalTeams,
} = fromTeam.adapter.getSelectors(getTeamState)

export const getEditingTeamSelector = createSelector(
  getTeamState,
  (state: fromTeam.State) => state.entities[state.editingTeamId]
)

export const getEditingTeamIdSelector = createSelector(
  getTeamState,
  fromTeam.getEditingTeamId
)





// WEBPACK FOOTER //
// ./src/app/shared/team/store/selectors/team.selectors.ts